<template>
  <div class="v2-page">
    <v2-order-detail
      v-if="shipmentOrder"
      :key="reloadKey"
      :shipment-order="shipmentOrder"
      @load-shipment="loadShipmentDetails"
    />
    <div
      v-else
      class="v2-page-loading"
    >
      <v2-spinner
        size="lg"
        label="Loading shipment..."
      />
    </div>
  </div>
</template>

<script>
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2OrderDetail from '@/views/v2/orders/V2OrderDetail.vue'
import store from '@/store'
import { GET_SHIPMENT } from '@/store/modules/shipment.module'

export default {
  name: 'V2Shipment',
  components: {
    V2Spinner,
    V2OrderDetail,
  },
  data() {
    return {
      shipmentOrder: null,
      reloadKey: 1,
    }
  },
  created() {
    this.loadShipmentDetails()
  },
  methods: {
    loadShipmentDetails() {
      const shipmentId = this.$route.params.shipmentId
      store.dispatch(GET_SHIPMENT, shipmentId)
        .then(res => {
          const shipment = res.data.data
          this.shipmentOrder = {
            ...shipment,
            shipmentId: shipment._id,
          }
          this.reloadKey++
        })
        .catch(() => {})
    },
  },
}
</script>
